import React from 'react'
import styled from 'styled-components'
import { object } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import { isEmptyObject } from '../../../../utils/helpers/helpers'
import { useOpcionais } from '../../../../contexts/OpcionaisContext'

const WrapperBotaoOpcionais = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 24px 0 8px 0;

  button {
    margin: 0;
  }

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    flex-direction: column;
    align-items: stretch;

    button {
      width: 100%;
    }
  }
`

const BotaoOpcionais = ( {
  botaoConfirmar,
  botaoCancelar,
  modalidadesEscolhidaOpcionais
} ) => {
  const { infoPagamento } = useOpcionais()

  function desabilitaButao() {
    if ( modalidadesEscolhidaOpcionais?.length === 0 ) {
      return true
    }
    if ( infoPagamento && infoPagamento.forma_pagamento === 'P' ) {
      return false
    }
    if ( infoPagamento && infoPagamento?.cvv?.length >= 3 ) {
      return false
    }
    return true
  }

  return (
    <WrapperBotaoOpcionais>
      {!isEmptyObject( botaoConfirmar ) && (
        <Button
          disabled={
            desabilitaButao()

          }
          onClick={ () => botaoConfirmar.acaoBotaoConfirmar() }
        >
          {botaoConfirmar.texto}
        </Button>
      )}

      {!isEmptyObject( botaoCancelar ) && (
        <Button
          hasSpaceBottom={ false }
          invertido
          onClick={ () => botaoCancelar.acaoBotaoCancelar() }
        >
          {botaoCancelar.texto}
        </Button>
      )}
    </WrapperBotaoOpcionais>
  )
}

BotaoOpcionais.propTypes = {
  'botaoCancelar': object.isRequired,
  'botaoConfirmar': object.isRequired,
  'modalidadesEscolhidaOpcionais': object.isRequired,
}

export default BotaoOpcionais
